import React, { useState } from 'react';

const FormSignInViaCreds = ({ onSubmit = () => {}, isLocked = false }) => {
  const [formData, setFormData] = useState({ email: '', password: '' });

  const handleChange = (e) => {
    setFormData((state) => ({ ...state, [e.target.name]: e.target.value }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit}>
      <input
        type="email"
        name="email"
        placeholder="Email"
        value={formData.email}
        onChange={handleChange}
        className="w-full mb-3 p-3 border rounded"
        required
      />
      <input
        type="password"
        name="password"
        placeholder="Password"
        value={formData.password}
        onChange={handleChange}
        className="w-full mb-2 p-3 border rounded"
        required
      />

      <button
        type="submit"
        className="w-full2 mt-4 py-4 px-12 rounded-full bg-indigo-600 hover:not-focus:bg-indigo-700 text-lg text-white font-bold p-2 disabled:opcaity-50"
        disabled={isLocked || !formData?.email || !formData?.password}
      >
        Login
      </button>
    </form>
  );
};

export default FormSignInViaCreds;
